<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="main-header">
    <div class="main-header-buttons">
      <button class="hide-sidebar" (click)="sideBarChange()">
        <i class="bi bi-window-sidebar" matTooltip="Open sidebar" *ngIf="!sidebarOpen"></i>
        <i class="bi bi-layout-sidebar" matTooltip="Close sidebar" *ngIf="sidebarOpen"></i>
      </button>
      <button class="hide-sidebar" (click)="startNewChat()"><i class="bi bi-pen" matTooltip="New chat"></i></button>
    </div>

    <div class="chat-header">
      <img *ngIf="messages.length > 1" src="assets/sia3.png" alt="Bot Logo" class="bot-logo" />
      <span *ngIf="messages.length > 1" class="bot-name">SIA Assistant</span>
    </div>
    <div class="header">
      <select [(ngModel)]="selectedModel">
        <option *ngFor="let model of models" [value]="model">{{ model }}</option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-auto sidebar-col">
      <nav class="sidebar" [class.open]="sidebarOpen">
        <div class="sidebar-header"></div>
        <ul class="conversations">
          <ng-container *ngFor="let conversation of conversations;">
            <li *ngIf="!conversation.is_deleted" (click)="loadSession(conversation)"
              [ngClass]="{'active-conversation': conversation.conversation_id === active_conversation_id}"
              class="conversation-item">
              <div class="conversation-content">
                <i class="bi bi-chat" style="color: #aaa;"></i>
                <span class="preview-text">{{ conversation.preview }}</span>
                <button class="btn btn-link p-0 delete-btn"
                  (click)="deleteConversation(conversation.conversation_id); $event.stopPropagation()"
                  title="Delete conversation">
                  <i class="bi bi-trash" style="color: #aaa;"></i>
                </button>
              </div>
            </li>
          </ng-container>
        </ul>
      </nav>
    </div>

    <div class="col chat-col" style="overflow-y: visible;">
      <div class="chat-container" [class.empty]="messages.length === 1">
        <div #chatBox class="chat-box">
          <div *ngFor="let msg of messages; trackBy: trackByMsgIndex" class="message"
            [ngClass]="{ 'user': msg.sender === 'user', 'bot': msg.sender !== 'user', 'has-chart': msg.charts?.length }">
            <span [innerHTML]="msg.text"></span>
            <div *ngIf="msg.charts?.length" class="chat-chart-container">
              <ng-container *ngFor="let chart of msg.charts">
                <plotly-plot *ngIf="chart" [data]="chart.data" [layout]="chart.layout" [config]="chart.config"
                  class="chat-chart"></plotly-plot>
              </ng-container>
            </div>
          </div>
          <div *ngIf="isLoading" class="typing-indicator">
            <span></span><span></span><span></span>
          </div>
        </div>

        <div class="h-text" *ngIf="messages.length === 1">
          <img src="assets/sia3.png" alt="SIA Logo" class="qip-logo" />
          <h2><span class="text-style-highlighted">SIA Assistant</span> leverages global patent data to deliver
            insights on innovation trends and technology competitiveness.</h2>
        </div>

        <div class="input-row">
          <input type="text" [(ngModel)]="userInput" (keyup.enter)="sendMessage()"
            [disabled]="isLoading"
            placeholder="Ask about a company's innovation or a technology theme..." />
          <button (click)="sendMessage()" [disabled]="isLoading">
            Send
          </button>
        </div>

        <div class="suggestions-container" *ngIf="messages.length === 1 && suggestions.length > 0">
          <div class="suggestion-list">
            <button *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)"
              class="suggestion-btn">{{ suggestion }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>